import { appsConfigClient } from "./lib/clients";
import LoginService from "./services/LoginService";

export const fallback = {};

/**
 * Get current app config
 * @returns {Promise<{
 *  name: string,
 *  slug: string,
 *  filters: Record<string, {
 *    title: string,
 *    kind: string,
 *    minMax: (dataStore: any) => [number, number],
 *    update: (dataStore: any, newValue: any) => any,
 *    toString: (dataStore: any) => any,
 *    payload: (dataStore: any) => any
 *  }>,
 *  emailAPIToken: string,
 *  mapboxToken: string,
 *  tablePresentation: (geolocationData: any) => string
 *  overlay: string,
 *  overlayTitle: string,
 *  pointsSizes: { mean: number, great: number },
 *  pointsProperties: (properties) => any,
 *  dashboardLink: string
 * }>} The app config
 */
export async function appConfig() {
  try {
    const url = new URL(window.location.href);
    const appName =
      url.searchParams.get("app") ??
      localStorage.getItem("app") ??
      url.hostname.split(".")[0];

    const response = await appsConfigClient.get(`/${appName}/config`, {
      headers: {
        Authorization: `Bearer ${LoginService.getAccessToken()}`,
      },
    });

    const rawConfigData = response?.data;
    if (rawConfigData) {
      /* eslint-disable no-eval */
      rawConfigData.tablePresentation = eval(rawConfigData.tablePresentation);
      rawConfigData.pointsProperties = eval(rawConfigData.pointsProperties);
      for (const filter of Object.values(rawConfigData.filters)) {
        filter.toString && (filter.toString = eval(filter.toString));
        filter.payload && (filter.payload = eval(filter.payload));
        filter.minMax && (filter.minMax = eval(filter.minMax));
        filter.update && (filter.update = eval(filter.update));
        filter.options && (filter.options = eval(filter.options));
      }
      /* eslint-enable no-eval */
    }

    const config = response?.data ?? fallback

    document.title = config.name;

    return config;
  } catch (error) {
    console.error(error);
    return fallback;
  }
}
